import Text from "ab-text";
import ParagraphText from "ab-paragraph-text";

import "./ab-mantra.scss";

const Mantra = ({
  title = "Este es el mantra de Abadía Retuerta",
  image = "/images/este-es-el-mandra-abadia-desk-x2.jpg",
  contenido,
}) => {
  return (
    <div className="ab-mantra">
      <img src={image?.mediaItemUrl} alt={title} />
      <div>
        <Text element="h2">{title}</Text>

        <ParagraphText content={contenido} singleColumn />
        {/* 
        <Text element="h4">Somos Atemporales</Text>
        <Text>
          Fusionamos pasado y presente para el futuro. Abadía Retuerta nació en
          el S.XII y vino para quedarse. Aquí no hay prisas, queremos que la
          marca trascienda, que perdure en el tiempo. Siempre con respeto,
          dedicación y con un espíritu de superación que nos ayuda a ser cada
          día mejores.
        </Text>

        <Text element="h4">Somos Sensibles</Text>
        <Text>
          En Abadía Retuerta somos capaces de emocionar. Ponemos alma y corazón
          en todo lo que hacemos.
        </Text>

        <Text element="h4">Somos Sensibles</Text>
        <Text>
          Lo que más valoramos es sorprender. Ser parte de sus recuerdos, de
          esas vivencias que te producen sentimientos de alegría, nostalgia,
          tranquilidad… emociones que no tienen precio.
        </Text>

        <Text element="h4">Somos Generosos</Text>
        <Text>
          Somos una marca que comparte todo lo que tiene, su legado histórico,
          su paraje, sus mejores uvas. Todo para que el consumidor lo disfrute y
          se sienta partícipe.
        </Text> */}
      </div>
    </div>
  );
};

export default Mantra;
